/* Paletas de cor do painel.
 *
 * O tema padrão do sistema é azul e vive direto no :root de index.css — não
 * tem entrada de CSS aqui, só o cartão na tela de seleção. As outras cinco
 * são geradas por scripts/build-theme-palettes.js em src/styles/theme-palettes.css,
 * onde cada uma vira um bloco :root[data-theme-palette="<id>"] com os tokens de
 * superfície e uma rampa que reveste as classes azuis/índigo do Tailwind.
 * É o mesmo desenho de styles/white-label-restricar.css, que é por domínio;
 * este é por empresa.
 *
 * Para mudar um tom, edite `ramp` abaixo e rode `npm run build:themes`.
 * A lista de ids precisa acompanhar THEME_PALETTES em
 * sistema-backend/src/services/companyService.js, que valida o que é gravado.
 *
 * As rampas saem das escalas do Tailwind (red, emerald, violet, slate, zinc),
 * então mantêm o mesmo contraste relativo entre os tons que o azul original —
 * um `text-blue-700` sobre `bg-blue-50` continua legível ao virar vermelho.
 */

export const DEFAULT_PALETTE = "azul";

/* Escala neutra escura das superfícies (menu lateral, hero). Cada paleta
   define a sua; o azul é o que já está no :root. */
export const PALETTES = [
  {
    id: "azul",
    label: "Azul",
    description: "Tema padrão do sistema",
    swatch: ["#043488", "#2563eb", "#60a5fa"],
  },
  {
    id: "vermelho",
    label: "Vermelho",
    description: "Vermelho quente, acento coral",
    swatch: ["#7f1d1d", "#dc2626", "#f87171"],
  },
  {
    id: "verde",
    label: "Verde",
    description: "Verde-esmeralda, acento menta",
    swatch: ["#064e3b", "#059669", "#34d399"],
  },
  {
    id: "roxo",
    label: "Roxo",
    description: "Violeta profundo, acento lilás",
    swatch: ["#4c1d95", "#7c3aed", "#a78bfa"],
  },
  {
    id: "cinza",
    label: "Cinza",
    description: "Ardósia sóbria, acento claro",
    swatch: ["#1e293b", "#475569", "#94a3b8"],
  },
  {
    id: "preto",
    label: "Preto",
    description: "Grafite, acento branco-gelo",
    swatch: ["#18181b", "#3f3f46", "#a1a1aa"],
  },
];

export const isValidPalette = (value) =>
  PALETTES.some((palette) => palette.id === value);

export const getPalette = (value) =>
  PALETTES.find((palette) => palette.id === value) || PALETTES[0];
